import { observer } from "mobx-react"
import * as React from "react"
import { DayPickerStep } from "./DayPickerStep"
import "../../utils/daypicker.css"
import { BookingButton } from "../../components/BookingButton"
import theme from "BookingSystem/theme"
import { Flex } from "rebass"
import styled from "styled-components"

@observer
export class DayPickerStepComp extends React.Component<{
  model: DayPickerStep
}> {
  StyledButton = styled(BookingButton)`
    background: white;
    color: black;
    height: 50px;
  `

  render() {
    const { model } = this.props

    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        bg={theme.colors.interactiveBackground}
        style={{
          height: window.innerWidth > 450 ? "50vh" : "45vh",
          width: "80vw"
        }}
        mb={[2, 0]}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <div
            style={{
              position: "relative",
              color: theme.colors.text,
              fontFamily: theme.fonts.secondary,
              fontSize: "1.75rem",
              bottom: -10,
              textTransform: "uppercase"
            }}
          >
            I'm visiting
          </div>
          <Flex
            justifyContent="center"
            fontSize={
              model.displayDate === "Today"
                ? ["4rem", "6rem"]
                : ["2rem", "5rem"]
            }
            style={{
              color: theme.colors.text,
              fontFamily: theme.fonts.tertiary,
              textTransform: "uppercase",
              fontWeight: 800
            }}
          >
            {model.displayDate}
          </Flex>
        </Flex>
        <Flex
          onClick={() => model.showDatePickerModal()}
          p={2}
          mr={3}
          fontSize={20}
          alignItems="center"
          style={{
            position: "relative",
            fontWeight: "bold",
            top: "50px",
            cursor: "pointer",
            background: theme.colors.callToAction,
            lineHeight: "1.25rem",
            textTransform: "uppercase",
            height: 45,
            width: "fit-content",
            padding: "2%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: theme.colors.text,
            borderRadius: 4
          }}
        >
          No, I'm visiting another day.
        </Flex>
      </Flex>
    )
  }
}
